﻿window.info_CountrySaldo = function () {

    var Top = 40;

    var margin = { top: Top, right: 20, bottom: 150, left: 100 },
        width = 960 - margin.left - margin.right,
        height = 500 - margin.top - margin.bottom;

    function initChart(id, x, y, labels) {
        d3.select("#" + id + " svg").remove();
        var svg = d3.select("#" + id).append("svg")
            .attr('class', 'chart')
            .attr("width", width + margin.left + margin.right)
            .attr("height", height + margin.top + margin.bottom)
            .append("g")
            .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

        svg.append("rect")
            .attr("width", "100%")
            .attr("height", "100%")
            .attr("fill", "white");

        var xGrid = svg.append("g").call(d3.axisBottom().tickFormat("").tickSize(height).ticks(xticks(labels), "f").scale(x));
        var yGrid = svg.append("g").call(d3.axisLeft().tickFormat("").tickSize(-width).scale(y));

        xGrid.selectAll("line").attr("stroke", "#ddd").attr("stroke-dasharray", "2,2");
        yGrid.selectAll("line").attr("stroke", "#ddd").attr("stroke-dasharray", "2,2");

        var xOffset = labels.length === 1 ? width / 2 : 0;
        var xAxis = svg.append("g")
            .attr("transform", "translate(" + xOffset + "," + height + ")")
            .call(d3.axisBottom(x).ticks(xticks(labels), "f").tickFormat(function (d) {
                return labels[d];
            }));

        if (labels.length > 1)
            xAxis.selectAll("text")
                .style("text-anchor", "end")
                .attr("dx", "-.8em")
                .attr("dy", ".15em")
                .attr("transform", "rotate(-65)");

        var yAxis = svg.append("g").call(d3.axisLeft(y));

        var group = svg.append("g").attr("clip-path", "url(#clip)");

        var clip = svg.append("defs").append("clipPath")
            .attr("id", "clip")
            .append("rect")
            .attr("id", "clip-rect")
            .attr('stroke', 'red')
            .attr("width", width)
            .attr("height", height);

        var chart = { svg: svg, xAxis: xAxis, yAxis: yAxis, xGrid: xGrid, yGrid: yGrid, group: group };

        return chart;
    }

    function xticks(xdata) {
        return xdata.length > 48 ? 48 : xdata.length;
    }

    function xscale(xdata) {
        return d3.scaleLinear().domain([0, xdata.length]).range([0, width]);
    }

    function yscale(data, maxfunc, minfunc) {
        var ymax = d3.max(data, maxfunc);
        var ymin = d3.min(data, minfunc);

        ymax = ymax + (ymax - ymin) * 0.1;
        ymin = ymin - (ymax - ymin) * 0.1;

        return d3.scaleLinear().domain([ymin, ymax]).range([height, 0]);
    }

    function updateChartOnClick(chart, newX, newY, labels, round) {

        chart.xAxis.call(d3.axisBottom(newX).ticks(xticks(labels), "f").tickFormat(function (d) { return labels[d]; }));
        chart.xAxis.selectAll("text")
            .style("text-anchor", "end")
            .attr("dx", "-.8em")
            .attr("dy", ".15em")
            .attr("transform", "rotate(-65)");

        chart.yAxis.call(d3.axisLeft(newY));

        chart.yGrid.call(d3.axisLeft().tickFormat("").tickSize(-width).scale(newY));
        chart.yGrid.selectAll("line").attr("stroke", "#ddd").attr("stroke-dasharray", "2,2");

        chart.xGrid.call(d3.axisBottom().tickFormat("").tickSize(height).ticks(xticks(labels), "f").scale(newX));
        chart.xGrid.selectAll("line").attr("stroke", "#ddd").attr("stroke-dasharray", "2,2");

        var vLine = d3.line()
            .x(function (d, i) { return newX(i); })
            .y(function (d) { return newY(round ? d | 0 : d); });

        chart.svg.selectAll(".dataline").attr("d", function (d) { return vLine(d.values); });

        for (var i = 0; i < 10; i++)
            chart.svg.selectAll("#dots" + i).selectAll("circle")
                .attr("cx", function (d, i) { return newX(i); })
                .attr("cy", function (d) { return newY(round ? d | 0 : d); });
    }

    function updateChart(chart, x, y, labels, round) {
        // recover the new scale
        var newX = d3.event.transform.rescaleX(x);
        var newY = d3.event.transform.rescaleY(y);

        // update axes with these new boundaries
        chart.xAxis.call(d3.axisBottom(newX).ticks(xticks(labels), "f").tickFormat(function (d) { return labels[d]; }));
        chart.xAxis.selectAll("text")
            .style("text-anchor", "end")
            .attr("dx", "-.8em")
            .attr("dy", ".15em")
            .attr("transform", "rotate(-65)");

        chart.yAxis.call(d3.axisLeft(newY));

        chart.yGrid.call(d3.axisLeft().tickFormat("").tickSize(-width).scale(newY));
        chart.yGrid.selectAll("line").attr("stroke", "#ddd").attr("stroke-dasharray", "2,2");

        chart.xGrid.call(d3.axisBottom().tickFormat("").tickSize(height).ticks(xticks(labels), "f").scale(newX));
        chart.xGrid.selectAll("line").attr("stroke", "#ddd").attr("stroke-dasharray", "2,2");

        var vLine = d3.line()
            .x(function (d, i) { return newX(i); })
            .y(function (d) { return newY(round ? d | 0 : d); });

        chart.svg.selectAll(".dataline").attr("d", function (d) { return vLine(d.values); });

        for (var i = 0; i < 10; i++)
            chart.svg.selectAll("#dots" + i).selectAll("circle")
                .attr("cx", function (d, i) { return newX(i); })
                .attr("cy", function (d) { return newY(round ? d | 0 : d); });
    }

    function getRandomColors(count) {
        var result = Array(count);
        for (var j = 0; j < count; j++) {
            result[j] = getColor();
        }
        return result;
    }

    function getColor() {
        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }

    var instance = {

        chartCountrySaldo: function () {

            var data = $("#countrysaldo_chartdata").val();
            if (data == undefined || data === "" || data == null)
                return; 

            var dataArray = JSON.parse(data);
            if (dataArray.length == 0)
                return;
            var titles = new Array(dataArray.length);
            var sec = new Array(dataArray.length);
            var xdata = new Array(dataArray[0].Data.length);
            var ydata = new Array(dataArray.length);
            
            for (var j = 0; j < dataArray.length; j++) {
                titles[j] = dataArray[j].Title;
                sec[j] = true;
                var dictionary = dataArray[j].Data;
                var jj = 0;
                ydata[j] = new Array(dataArray[j].Data.length);
                for (var key in dictionary) {
                    if (Object.prototype.hasOwnProperty.call(dictionary, key)) {
                        xdata[jj] = key;
                        ydata[j][jj] = dictionary[key];
                        jj++;
                    }
                }
            }

            // цвета разделов
            var colors = getRandomColors(titles.length);

            //num - номер раздела, isScale: участвует в расчете по y
            //time - шкала времени, series - массив данных
            var data = { num: -1, isScaleY: false, time: xdata, series: [] };

            this.loadDataSeries(sec, data, xdata, ydata, titles);

            margin.top = Top;
            if (data.series.length > 2)
                margin.top = Top * ((titles.length - 2) / 2);

            var labels = xdata;

            var maxfunc = function (d) {
                if (d.isScale)
                    return Math.max.apply(null, d.values);
            };
            var minfunc = function (d) {
                if (d.isScale)
                    return Math.min.apply(null, d.values);
            };

            var x = xscale(xdata);
            var y = yscale(data.series, maxfunc, minfunc);

            var chart = initChart("countrysaldo_chart", x, y, labels);

            var vLine = d3.line()
                .x(function (d, i) { return x(i); })
                .y(function (d) { return y(d); });

            var vArea = d3.area()
                .x(function (d, i) { return x(i); })
                .y0(function (d) { return y(d); }).
                y1(function (d) { return y(-d); });

            var idx = 0;
            for (var i = 0; i < sec.length; i++) {
                if (!sec[i]) continue;

                chart.group.append("path")
                    .attr("id", "line" + i)
                    .attr("active", "1")
                    .attr("fill", "none")
                    .attr("stroke", colors[i])
                    .attr('class', 'dataline')
                    .data([data.series[idx]])
                    .attr("d", function (d) {
                        return vLine(d.values);
                    });

                idx++;
            }

			var svg = d3.select("svg.chart");

            idx = 0;
            for (var i = 0; i < sec.length; i++) {
                if (!sec[i]) continue;

                svg.append("text")
                    .attr("id", "text" + i)
                    .attr("x", margin.left)
                    .attr("y", 15 + idx * 15)
                    .attr("line", i)
                    .style("fill", colors[i])
                    .style("font-size", "12px")
                    .style("font-weight", "normal")
                    .style("cursor", "pointer")
                    .text(titles[i])
                    .on("click", function () {
                        var n = this.getAttribute('line');
                        var line = d3.select("#line" + n);
                        var newOpacity = line.attr("active") == '1' ? 0 : 1;
                        var isView = newOpacity == 0 ? false : true;
                        sec[n] = isView;
                        line.style("opacity", newOpacity);
                        line.attr("active", newOpacity);
                        d3.select("#text" + n).style('fill', newOpacity == 0 ? '#ccc' : colors[n]);

                        for (var p = 0; p < data.series.length; p++) {
                            if (data.series[p].num == n)
                                data.series[p].isScale = isView;
                        }
                        x = xscale(xdata);
                        y = yscale(data.series, maxfunc, minfunc);

                        updateChartOnClick(chart, x, y, labels, true);

                    });

                idx++;
            }

            // Set the zoom and Pan features: how much you can zoom, on which part, and what to do when there is a zoom
            var zoom = d3.zoom()
                .scaleExtent([.5, 20])  // This control how much you can unzoom (x0.5) and zoom (x20)
                .extent([[0, 0], [width, height]])
                .translateExtent([[0, 0], [width, height]])
                .on("zoom", function () { updateChart(chart, x, y, labels, true); });

            svg.call(zoom);
        },

        loadDataSeries: function (sec, data, xdata, ydata, titles) {
            for (var j = 0; j < sec.length; j++) {
                if (sec[j]) {
                    var datai = [];
                    for (var i = 0; i < xdata.length; i++) {
                        datai.push(ydata[j][i]);
                    }
                    data.series.push({ num: j, isScale: true, name: titles[j], values: datai });
                }
            }
        },

    };

    return instance;

}();